import React, { useState, useEffect } from "react";
import { db } from "../../firebase/config";
import { collection, onSnapshot, doc, updateDoc, addDoc, orderBy, query } from "firebase/firestore";
import { useTheme } from "../../context/ThemeContext";
import Header from "../../components/Header";

const PLANES = ['starter', 'advanced', 'pro'];
const ESTADOS = ['pendiente_activacion', 'trial', 'activa', 'suspendida', 'cancelada'];

const ESTADO_COLORS = {
  pendiente_activacion: { bg: 'rgba(255,179,0,0.15)', color: '#FFB300', label: 'Pendiente' },
  trial: { bg: 'rgba(0,184,255,0.15)', color: '#00B8FF', label: 'Trial' },
  activa: { bg: 'rgba(0,208,132,0.15)', color: '#00D084', label: 'Activa' },
  suspendida: { bg: 'rgba(255,71,87,0.15)', color: '#FF4757', label: 'Suspendida' },
  cancelada: { bg: 'rgba(174,182,196,0.15)', color: '#AEB6C4', label: 'Cancelada' },
};

const PLAN_COLORS = {
  starter: { bg: 'rgba(0,184,255,0.15)', color: '#00B8FF' },
  advanced: { bg: 'rgba(0,208,132,0.15)', color: '#00D084' },
  pro: { bg: 'rgba(180,120,255,0.15)', color: '#B478FF' },
};

export default function Clinicas() {
  const { theme } = useTheme();
  const [clinicas, setClinicas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalDetalle, setModalDetalle] = useState(null);
  const [modalNueva, setModalNueva] = useState(false);
  const [filtroEstado, setFiltroEstado] = useState('todas');
  const [nueva, setNueva] = useState({ nombre: '', email: '', plan: 'starter', estado: 'pendiente_activacion' });

  const btnPrimaryStyle = { background: `linear-gradient(135deg, ${theme.accent}, ${theme.accentDark})`, border: 'none', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: '#FFFFFF', fontWeight: '600', fontFamily: "'Montserrat', sans-serif" };
  const btnSecondaryStyle = { background: 'transparent', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: theme.secondary, fontFamily: "'Montserrat', sans-serif" };
  const inputStyle = { width: '100%', padding: '10px 14px', fontSize: '13px', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', outline: 'none', color: theme.primary, background: theme.bgInput, boxSizing: 'border-box', fontFamily: "'Montserrat', sans-serif" };
  const labelStyle = { fontSize: '11px', color: theme.secondary, display: 'block', marginBottom: '6px', fontWeight: '500', letterSpacing: '1px' };
  const overlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: theme.bgOverlay, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
  const modalStyle = { background: theme.bgModal, borderRadius: '16px', padding: '28px', width: '100%', maxWidth: '480px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.4)', border: `0.5px solid ${theme.border}` };

  useEffect(() => {
    const q = query(collection(db, 'clinicas'), orderBy('creadoEn', 'desc'));
    const unsub = onSnapshot(q, snap => { setClinicas(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); });
    return unsub;
  }, []);

  async function activarTrial(clinicaId) {
    const fin = new Date(); fin.setDate(fin.getDate() + 30);
    const clinica = clinicas.find(c => c.id === clinicaId);
    await updateDoc(doc(db, 'clinicas', clinicaId), { estado: 'trial', trialInicio: new Date(), trialFin: fin });
    
    try {
      await fetch('https://us-central1-deluxe-software.cloudfunctions.net/notificarTrialActivado', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombreClinica: clinica?.nombre, email: clinica?.email, trialFin: fin.toLocaleDateString('es-AR') })
      });
    } catch (e) { console.warn('Error al enviar email de trial:', e); }
    
    setModalDetalle(null);
  }

  async function cambiarEstado(clinicaId, estado) {
    await updateDoc(doc(db, 'clinicas', clinicaId), { estado });
    setModalDetalle(prev => prev ? { ...prev, estado } : null);
  }

  async function cambiarPlan(clinicaId, plan) {
    await updateDoc(doc(db, 'clinicas', clinicaId), { plan });
    setModalDetalle(prev => prev ? { ...prev, plan } : null);
  }

  async function crearClinica() {
    if (!nueva.nombre || !nueva.email) return;
    await addDoc(collection(db, 'clinicas'), { ...nueva, creadoEn: new Date(), cantidadMedicos: 0, cantidadRecepcionistas: 0, cantidadAdministrativos: 0 });
    setModalNueva(false);
    setNueva({ nombre: '', email: '', plan: 'starter', estado: 'pendiente_activacion' });
  }

  const clinicasFiltradas = filtroEstado === 'todas' ? clinicas : clinicas.filter(c => c.estado === filtroEstado);

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <Header titulo="Clínicas" backLabel="Dashboard" backRuta="/dashboard" />
      <div style={{ padding: '24px', background: theme.bg }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {['todas', ...ESTADOS].map(e => (
              <button key={e} onClick={() => setFiltroEstado(e)} style={{ padding: '5px 12px', fontSize: '11px', borderRadius: '99px', cursor: 'pointer', border: filtroEstado === e ? 'none' : `0.5px solid ${theme.borderInput}`, background: filtroEstado === e ? theme.accent : 'transparent', color: filtroEstado === e ? '#FFFFFF' : theme.secondary, fontFamily: "'Montserrat', sans-serif", fontWeight: filtroEstado === e ? '600' : '400' }}>
                {e === 'todas' ? 'Todas' : ESTADO_COLORS[e]?.label || e}
              </button>
            ))}
          </div>
          <button onClick={() => setModalNueva(true)} style={btnPrimaryStyle}>+ Nueva clínica</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '12px' }}>
          {loading
            ? <div style={{ color: theme.secondary, padding: '48px', textAlign: 'center' }}>Cargando...</div>
            : clinicasFiltradas.length === 0
              ? <div style={{ color: theme.secondary, padding: '48px', textAlign: 'center', fontSize: '13px' }}>No hay clínicas en este estado</div>
              : clinicasFiltradas.map(c => {
                  const estado = ESTADO_COLORS[c.estado] || { bg: theme.bgCard, color: theme.secondary, label: c.estado };
                  const plan = PLAN_COLORS[c.plan] || { bg: theme.bgCard, color: theme.secondary };
                  const creadoEn = c.creadoEn?.toDate ? c.creadoEn.toDate().toLocaleDateString('es-AR') : '—';
                  const trialFin = c.trialFin?.toDate ? c.trialFin.toDate().toLocaleDateString('es-AR') : null;
                  return (
                    <div key={c.id} onClick={() => setModalDetalle(c)} style={{ background: theme.bgCard, borderRadius: '12px', padding: '18px 20px', border: `0.5px solid ${theme.border}`, cursor: 'pointer', transition: 'all 0.2s' }}
                      onMouseEnter={e => e.currentTarget.style.borderColor = theme.accent}
                      onMouseLeave={e => e.currentTarget.style.borderColor = theme.border}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                        <div style={{ fontSize: '15px', fontWeight: '600', color: theme.primary }}>{c.nombre}</div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '99px', background: estado.bg, color: estado.color, fontWeight: '500' }}>{estado.label}</span>
                          <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '99px', background: plan.bg, color: plan.color, fontWeight: '500', textTransform: 'uppercase' }}>{c.plan}</span>
                        </div>
                      </div>
                      <div style={{ fontSize: '12px', color: theme.secondary, marginBottom: '4px' }}>{c.email}</div>
                      <div style={{ fontSize: '11px', color: theme.secondary, marginTop: '8px', opacity: 0.7 }}>
                        Alta: {creadoEn}{trialFin && ` · Trial hasta: ${trialFin}`}
                      </div>
                    </div>
                  );
                })
          }
        </div>
      </div>

      {modalDetalle && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <span style={{ fontSize: '16px', fontWeight: '600', color: theme.primary }}>{modalDetalle.nombre}</span>
              <button onClick={() => setModalDetalle(null)} style={{ background: 'none', border: 'none', color: theme.secondary, cursor: 'pointer', fontSize: '20px' }}>×</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px' }}>
              {[['Email', modalDetalle.email], ['Estado', ESTADO_COLORS[modalDetalle.estado]?.label || modalDetalle.estado], ['Plan', modalDetalle.plan?.toUpperCase()], modalDetalle.trialFin ? ['Trial hasta', modalDetalle.trialFin?.toDate ? modalDetalle.trialFin.toDate().toLocaleDateString('es-AR') : '—'] : null].filter(Boolean).map(([label, valor]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 14px', background: theme.bg, borderRadius: '8px', border: `0.5px solid ${theme.border}` }}>
                  <span style={{ fontSize: '12px', color: theme.secondary }}>{label}</span>
                  <span style={{ fontSize: '12px', color: theme.primary, fontWeight: '500' }}>{valor}</span>
                </div>
              ))}
            </div>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '11px', color: theme.secondary, marginBottom: '8px', letterSpacing: '1px', fontWeight: '600' }}>CAMBIAR ESTADO</div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {ESTADOS.map(e => (
                  <button key={e} onClick={() => cambiarEstado(modalDetalle.id, e)} style={{ padding: '5px 10px', fontSize: '11px', borderRadius: '99px', cursor: 'pointer', border: modalDetalle.estado === e ? 'none' : `0.5px solid ${theme.borderInput}`, background: modalDetalle.estado === e ? ESTADO_COLORS[e]?.color : 'transparent', color: modalDetalle.estado === e ? '#FFFFFF' : theme.secondary, fontFamily: "'Montserrat', sans-serif" }}>
                    {ESTADO_COLORS[e]?.label || e}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: '24px' }}>
              <div style={{ fontSize: '11px', color: theme.secondary, marginBottom: '8px', letterSpacing: '1px', fontWeight: '600' }}>CAMBIAR PLAN</div>
              <div style={{ display: 'flex', gap: '6px' }}>
                {PLANES.map(p => (
                  <button key={p} onClick={() => cambiarPlan(modalDetalle.id, p)} style={{ padding: '5px 10px', fontSize: '11px', borderRadius: '99px', cursor: 'pointer', border: modalDetalle.plan === p ? 'none' : `0.5px solid ${theme.borderInput}`, background: modalDetalle.plan === p ? PLAN_COLORS[p]?.color : 'transparent', color: modalDetalle.plan === p ? '#FFFFFF' : theme.secondary, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
                    {p}
                  </button>
                ))}
              </div>
            </div>
            {modalDetalle.estado === 'pendiente_activacion' && (
              <button onClick={() => activarTrial(modalDetalle.id)} style={{ ...btnPrimaryStyle, width: '100%', padding: '12px' }}>
                Activar trial de 30 días
              </button>
            )}
          </div>
        </div>
      )}

      {modalNueva && (
        <div style={overlayStyle}>
          <div style={{ ...modalStyle, maxWidth: '420px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <span style={{ fontSize: '16px', fontWeight: '600', color: theme.primary }}>Nueva clínica</span>
              <button onClick={() => setModalNueva(false)} style={{ background: 'none', border: 'none', color: theme.secondary, cursor: 'pointer', fontSize: '20px' }}>×</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div><label style={labelStyle}>NOMBRE</label><input value={nueva.nombre} onChange={e => setNueva({...nueva, nombre: e.target.value})} placeholder="Clínica XYZ" style={inputStyle} /></div>
              <div><label style={labelStyle}>EMAIL</label><input value={nueva.email} onChange={e => setNueva({...nueva, email: e.target.value})} placeholder="admin@clinica.com" style={inputStyle} /></div>
              <div><label style={labelStyle}>PLAN</label>
                <select value={nueva.plan} onChange={e => setNueva({...nueva, plan: e.target.value})} style={inputStyle}>
                  {PLANES.map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '24px' }}>
              <button onClick={crearClinica} style={{ ...btnPrimaryStyle, flex: 1, padding: '11px' }}>Crear clínica</button>
              <button onClick={() => setModalNueva(false)} style={{ ...btnSecondaryStyle, flex: 1, padding: '11px' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}